const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/stats/creations.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { getCreationsByMonth } from "@/components/charts/creations/monthly";
import { getCreationsByYear } from "@/components/charts/creations/yearly";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/stats/creations")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context
  }) => {
    const {
      queryClient
    } = context;
    await Promise.allSettled([queryClient.prefetchQuery({
      queryKey: ["creations-by-month"],
      queryFn: () => getCreationsByMonth().catch(() => null)
    }), queryClient.prefetchQuery({
      queryKey: ["creations-by-year"],
      queryFn: () => getCreationsByYear().catch(() => null)
    })]);
  },
  head: () => {
    return {
      meta: [{
        title: i18n.t("stats.creations.meta.title")
      }, {
        name: "description",
        content: i18n.t("stats.creations.meta.description")
      }]
    };
  }
});